import { Chip } from "@mui/material";

export const Chips = (props: any) => {
  return (
    <>
      {
        <Chip
          label={`${props.count}`}
          style={{
            backgroundColor: props.chipColor,
            color: props.chipFontColor,
            fontWeight: 600,
            fontSize: 10,
            fontFamily: "Public Sans",
          }}
          sx={{
            "& .MuiChip-label": {
              fontWeight: 700,
            },
            borderRadius: "8px",
          }}
        />
      }
    </>
  );
};
